export default __webpack_public_path__ + "static/media/Sandals of the Faceless Sphinx.4f60592c.jpg";